module.exports = __webpack_public_path__ + "static/media/icon-star-blue.f215ad7a.svg";